import { render } from "./OrderActivity.vue?vue&type=template&id=bdd58cc0"
import script from "./OrderActivity.vue?vue&type=script&lang=js"
export * from "./OrderActivity.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__